var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSushi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:url(#SVGID_3_);}\n\t.st2{fill:url(#SVGID_4_);}\n\t.st3{fill:url(#SVGID_5_);}\n\t.st4{fill:#0E0F23;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st6{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.6442,
    y1: 1011.5057,
    x2: 24.3328,
    y2: 998.8395,
    gradientTransform: "matrix(1 0 0 -1 -12 1012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA52A0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5,2.3L23.6,15l-4.6,6.8L0.4,9L5,2.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6818,
    y1: 1012.3904,
    x2: 27.3705,
    y2: 999.7241,
    gradientTransform: "matrix(1 0 0 -1 -12 1012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA52A0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.6,15c-1.6,2.3-7,1.4-12.1-2.2C6.3,9.3,3.5,4.6,5,2.3c1.6-2.3,7-1.4,12.1,2.2C22.3,7.9,25.1,12.7,23.6,15z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.616,
    y1: 1010.6239,
    x2: 21.3047,
    y2: 997.9576,
    gradientTransform: "matrix(1 0 0 -1 -12 1012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA52A0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19,21.7c-1.6,2.3-7,1.4-12.1-2.2s-8-8.2-6.4-10.6c1.6-2.3,7-1.4,12.1,2.2C17.7,14.7,20.5,19.4,19,21.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.6,15C23.6,15,23.6,15,23.6,15l-4.6,6.8l0,0c-1.6,2.3-7,1.3-12.1-2.2c-1-0.7-1.9-1.4-2.8-2.2 c0.7-0.1,1.6-0.5,2.5-1.5c1.6-1.7,2.4-2.1,3.1-2c0.7,0,1.5,0.7,2.8,2.4c1.3,1.7,3.1,2.2,4.2,1.3c0.1-0.1,0.2-0.1,0.3-0.2 c0.9-0.7,1.2-1,2.9-4.2c0.4-0.8,1.8-2.1,3.7-1.5C24.1,13,24.1,14.1,23.6,15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.9,14.6c-1.4,2-6.3,1-11-2.3C7.1,9,4.3,4.8,5.7,2.8s6.3-1,11,2.3S24.2,12.6,22.9,14.6z M18.5,11.6 c-0.7,1-3.1,0.5-5.5-1.1c-2.3-1.6-3.7-3.7-3-4.7c0.7-1,3.1-0.5,5.5,1.1C17.8,8.5,19.2,10.6,18.5,11.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M4.6,4.6c0-0.1-0.1-0.2-0.2-0.1S4.2,4.6,4.2,4.7C4.3,5,4.4,5.2,4.4,5.4c0,0.1,0.1,0.2,0.2,0.1 c0.1,0,0.2-0.1,0.1-0.2C4.7,5.1,4.7,4.9,4.6,4.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M5.1,6.2C5.1,6.1,5,6,4.9,6.1S4.8,6.2,4.8,6.3c1.1,2.5,3.4,5.2,6.4,7.2c0.1,0.1,0.2,0,0.3,0 c0.1-0.1,0-0.2,0-0.3C8.4,11.2,6.2,8.6,5.1,6.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M17.2,16c-0.1,0-0.2,0-0.2,0.1c0,0.1,0,0.2,0.1,0.2c0.3,0.1,0.7,0.2,1,0.3c0.1,0,0.2,0,0.2-0.1 c0-0.1,0-0.2-0.1-0.2C17.9,16.2,17.5,16.1,17.2,16z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19,16.4c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.8,0.1,1.7,0.2,2.4,0.1c0.1,0,0.2-0.1,0.2-0.2 c0-0.1-0.1-0.2-0.2-0.2C20.6,16.6,19.8,16.5,19,16.4z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/SUSHI.ce3f3780ee9d3f6909a035236d4ece0d.svg";
export { ForwardRef as ReactComponent };